import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DRAWER_CLASS_NAME = 'Drawer';
export const DRAWER_CLASS_SLOTS = ['root', 'content', 'drawer'] as const;

export type DrawerClassSlot = (typeof DRAWER_CLASS_SLOTS)[number];

export interface DrawerClasses {
	root: string;
	content: string;
	drawer: string;

	resizing: string;
	open: string;
	mobile: string;
	temporary: string;
}

export type DrawerClassKey = keyof DrawerClasses;

export const getDrawerUtilityClass = (slot: string) =>
	generateUtilityClass(DRAWER_CLASS_NAME, slot);

export const drawerClasses: DrawerClasses = generateUtilityClasses(
	DRAWER_CLASS_NAME,
	['root', 'content', 'drawer', 'mobile', 'open', 'resizing', 'temporary'],
);

export default drawerClasses;
